var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoringBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.934,
    height: 120.283,
    viewBox: "0 0 146.934 120.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_11",
    "data-name": "Uni\\xF3n 11",
    d: "M1.174,198.822a34.35,34.35,0,0,1,24.281-42.053l26.875-7.2c-.121-.382-.238-.769-.34-1.16A25.9,25.9,0,0,1,70.3,116.686l44.012-11.8a25.908,25.908,0,0,1,13.41,50.051l-5.7,1.526a34.355,34.355,0,0,1-20.465,51.005l-13.316,3.57L43.225,223.106A34.3,34.3,0,0,1,1.174,198.822Z",
    transform: "translate(0.002 -103.999)",
    fill: "#fff",
    opacity: 0.997
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoringBg2);
export default __webpack_public_path__ + "static/media/storingBg2.b8a6289c7e6a8360a3c6108fe9e88fc0.svg";
export { ForwardRef as ReactComponent };